import React from "react";
import BondNode from "components/BondTree/Node";
import DeviceCommand from "./DeviceCommand";

function DevicesCommands(props) {
  return (
    <BondNode
      {...props}
      customAttrComponent={(attr, value) => (
        <DeviceCommand
          key={attr}
          parentU={value["_"]}
          bond={props.bond}
          path={props.path + attr + "/"}
          label={attr}
        />
      )}
    />
  );
}

export default DevicesCommands;
